import marketoverview from '@/msp/components/marketoverview/market-overview.vue';
import marketschool from '@/msp/components/marketschool/market-school.vue';
import advantage from '@/msp/components/searchadvantage/advantage.vue';
import searchRelatedLinks from '@/msp/components/searchrelatedlinks/search-relatedlinks.vue';
import searchFilteredMspLinks from '@/msp/components/searchfilteredmsplinks/search-filteredmsplinks.vue';
import faqFunc from '../../../common/utilities/faqFunc';
import mvtAds from '@/common/components/mvtads/mvt-ads.vue';
import enJSON from '@/common/utilities/lang/en/footer.js';
import esJSON from '@/common/utilities/lang/es/footer.js';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtPagination from '@/common/components/mvtpagination/mvt-pagination.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import geoLandingMarketTrends from '@/geolanding/components/geolandingmarkettrends/geolanding-markettrends.vue';
import searchSeoLink from '@/msp/components/searchseolink/search-seolink.vue';
import searchGeoLink from '@/msp/components/searchgeolink/search-geolink.vue';
import searchFilterLink from '@/msp/components/searchgeolink/search-filterlink.vue';
import mvtBreadcrumb from '@/common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
import mvtCompliance from '@/common/components/mvtcompliance/mvt-compliance.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import searchAdsAgentConnection from '@/msp/components/searchads/search-adsagentconnection.vue';
import searchMarketTrends from '@/msp/components/searchmarkettrends/market-trends.vue';
import searchGeoContent from '@/msp/components/searchgeocontent/search-geo-content.vue';
import searchSchool from '@/msp/components/searchschool/search-school.vue';
import mvtReorder from '@/common/components/mvtreorder/mvt-reorder.vue';

//doto cw-4162:step3.5 redesign footer model

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'searchFooter',
    inject: ['$eventBus'],
    components: {
        mvtPagination,
        marketoverview,
        marketschool,
        advantage,
        searchFilterLink,
        searchRelatedLinks,
        searchFilteredMspLinks,
        mvtAds,
        mvtListLinks,
        mvtFaq,
        mvtNearby,
        geoLandingMarketTrends,
        searchSeoLink,
        searchGeoLink,
        mvtBreadcrumb,
        mvtCompliance,
        mvtHotleadForm,
        mvtFooter,
        searchAdsAgentConnection,
        searchMarketTrends,
        searchGeoContent,
        searchSchool,
        mvtReorder,
    },
    props: {
        restAds: {
            type: Number,
            default: 0,
        },
        isAdsBanner: {
            type: Boolean,
            default: false,
        },
        isSplitView: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hotleadKey: 0,
            faq: [],
            popularSearchesList: [],
            // showMore: false,
            componentMounted: false,
            hotArticles: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit', 'getPopularList', 'getPhoneNumber']),
        ...mapGetters('msp', [
            'geo',
            'getGeoDisplayText',
            'getNearbyCities',
            'getNearbyZipcodes',
            'getNearbyNeighborhood',
            'getNearbyCounties',
            'getIsCommunitySearch',
            'getLocalHighlightGeo',
            'getMarketInfo',
            'getSnapshotData',
            'msp',
            'getSchoolData',
            'hasGeoInfoInSearchUrl',
        ]),
        baseUrl() {
            let currentPath = this.msp.viewUrl.replace(/^\//, '');
            currentPath = currentPath.replace(/\/p-\d+\/?/i, '/');
            return `${this.glb.appUrl}${currentPath}`;
        },
        pageDisplayLimit() {
            return this.glb.isPhone ? 3 : 5;
        },
        getRestAds() {
            return this.restAds;
        },
        marketTrendSummary() {
            return this.marketTrendsSummary;
        },
        checkNearBy() {
            return this.msp.nearbyCities.length;
        },
        hasGeoInfo() {
            return this.geo.hasGeoInfo;
        },
        hideFaqSection() {
            return this.glb.url.includes('/es/') || this.glb.rentals || this.geo.geoType == 'GPS';
        },
        hideOpenhomes() {
            return ['OH', 'KY'].indexOf(this.geo.state) > -1;
        },
        getCityStateName() {
            let name = '';

            if (this.geo.city) {
                name = this.geo.city + ' ' + this.geo.state;
            }

            return name;
        },
        getCityName() {
            return this.geo.city;
        },
        mspStatusChanged() {
            return this.msp.filter.isActive;
        },
        hotleadOpt() {
            const opt = {
                hotleadTitle: this.molang('search.common.notRelevantResult'),
                hotleadType: `MapSearchInlineBottom${this.msp.filter.isActive ? '' : '_Sold'}`,
                buttonText: this.molang('search.common.usQuestion'),
                comment: this.molang('search.common.hotleadcomments') + this.getGeoDisplayText,
                showDisclaimer: false,
                showComment: true,
                hideProfile: true,
                hideIncentive: true,
                showZipcode: true,
            };
            //
            if (!this.msp.filter.rentals) {
                opt.hotleadTitle = 'Connect with an agent';
                opt.hotleadType = 'AgentConnectionBottom';
                opt.buttonText = this.molang('dpp.hotleadForm.submit');
                opt.comment = null;
                opt.showComment = false;
            }
            return opt;
        },
        hasSeoLinks() {
            return this.getNearbyCities.length || this.getNearbyZipcodes.length || this.getNearbyNeighborhood.length || this.getNearbyCounties.length;
        },
        getFAQ() {
            return this.faq || [];
        },
        listings() {
            return [
                {
                    icon: 'icon-money',
                    title: 'Best Value Homes in',
                    url: `${this.glb.appUrl}${this.glb.geo.geoPath}single-family/sortby-pricepersqft-asc/`,
                    options: {
                        filter: 'best-value',
                        value: this.geo.baseUrl,
                    },
                },
                {
                    icon: 'icon-trend-down',
                    title: 'Price Reduced Properties in',
                    url: `${this.glb.appUrl}${this.glb.geo.geoPath}reduced-30/`,
                    options: {
                        filter: 'price',
                        value: this.geo.baseUrl,
                    },
                },
                {
                    icon: 'icon-open-house',
                    title: 'Open Houses in',
                    url: `${this.glb.appUrl}${this.glb.geo.geoPath}open-houses/`,
                    options: {
                        filter: 'open',
                        value: this.geo.baseUrl,
                    },
                },
            ];
        },
        propertyTypeData() {
            var propertyTypes = [
                {
                    class: 'circle tiny default active icon-property-single-family',
                    text: 'House',
                    value: 'single-family',
                    url: `${this.glb.appUrl}${this.msp.geo.geoPath}single-family/`,
                },
                {
                    class: 'circle tiny default active icon-property-condo',
                    text: this.glb.rentals ? 'Apartment' : 'Condo/Townhouse',
                    value: 'condos',
                    url: `${this.glb.appUrl}${this.msp.geo.geoPath}condos/`,
                },
                {
                    class: 'circle tiny default active icon-property-other',
                    text: 'Other',
                    value: 'other',
                    url: `${this.glb.appUrl}${this.msp.geo.geoPath}other/`,
                },
            ];
            if (!this.glb.rentals) {
                propertyTypes.push(
                    ...[
                        {
                            class: 'circle tiny default active icon-property-multi-family',
                            text: 'Multi-family',
                            value: 'multi-family',
                            url: `${this.glb.appUrl}${this.msp.geo.geoPath}multi-family/`,
                        },
                        {
                            class: 'circle tiny default active icon-property-lot',
                            text: 'Lot/Land',
                            value: 'land',
                            url: `${this.glb.appUrl}${this.msp.geo.geoPath}land/`,
                        },
                        {
                            class: 'circle tiny default active icon-property-mobile',
                            text: 'Mobile',
                            value: 'mobile',
                            url: `${this.glb.appUrl}${this.msp.geo.geoPath}mobile/`,
                        },
                    ]
                );
            }
            return propertyTypes;
        },
        showNearby() {
            return this.msp.searchType === 'COUNTY' || this.msp.searchType === 'STATE';
        },
        getGeoTitle() {
            if (this.msp.geo && this.msp.geo.hasGeoInfo) {
                if (this.msp.searchType === 'NEIGHBORHOOD') {
                    return this.msp.geo.neighborhood;
                } else {
                    return this.msp.searchInput || this.msp.geo.formatAddress;
                }
            }
            return this.glb.geo.formatAddress;
        },
        getMaxAllowedPageCount() {
            return this.msp.pageCount > 99 ? 99 : this.msp.pageCount;
        },
        pageCountLabel() {
            const {filter, geo, searchType, totalCount} = this.msp;
            const propertyTypes = filter?.propertyType || [];
            const isPlural = totalCount > 1;

            const propertyTypeEnum = {
                'single-family': 'House',
                condos: 'Condo',
                'multi-family': 'Multi-family home',
                land: 'Property',
                mobile: 'Mobile home',
                other: 'Property',
                ...(filter.rentals ? {condos: 'Apartment'} : {}),
            };
            const propertyTypePluralEnum = {
                'House': 'Houses',
                'Condo': 'Condos',
                'Apartment': 'Apartments',
                'Multi-family home': 'Multi-family homes',
                'Property': 'Properties',
                'Mobile home': 'Mobile homes',
                'Home': 'Homes',
            };

            let labelPrefix = 'House';
            let labelSuffix = geo.formatAddress;

            if((searchType === 'ZIPCODE' || searchType === 'NEIGHBORHOOD')) {
                labelPrefix = 'Home';
                if(searchType === 'ZIPCODE') {
                    labelSuffix = geo.zipcode;
                } else {
                    labelSuffix = `${geo.neighborhood} ${geo.city}`;
                }
            }
            if(!propertyTypes?.length) {
                labelPrefix = 'Home';
            } else if(propertyTypes?.length > 1) {
                const mainTypes = ['single-family', 'condos', 'mobile'].some(type => propertyTypes.includes(type));
                labelPrefix = mainTypes ? 'Home' : 'Property';
            } else {
                const propertyType = propertyTypes.length && propertyTypes[0];
                labelPrefix = propertyTypeEnum[propertyType] || 'Home';
            }

            if (isPlural ) {
                labelPrefix = propertyTypePluralEnum[labelPrefix];
            }
            if (filter.rentals === 1) {
                labelPrefix += ' for rent';
            } else if (!filter.soldDateRange) {
                labelPrefix += ' for sale';
            }
            return `${labelPrefix} in <b class="text-bold">${labelSuffix}</b>`;
        },
        footerOrder() {
            if (this.getSplit('movoto-seo-optimisation-CW-4173')) {
                return [
                    'ads1',
                    'pagination',
                    'hotlead',
                    'breadcrumb',
                    'geoLinks',
                    'filterLinks',
                    'dataList',
                    'ads2',
                    'marketTrendsBlock',
                    'schoolBlock',
                    'neighborhood',
                    'realEstateLinks',
                    'popularList',
                    'relatedLinks',
                    'ads3',
                    'faq',
                    'ads4',
                    'popularSearches',
                    'bannerAd',
                    'mvtFooter',
                ];
            }
            return [
                'ads1',
                'pagination',
                'hotlead',
                'breadcrumb',
                'neighborhood',
                'filterLinks',
                'ads2',
                'marketTrendsBlock',
                'ads3',
                'faq',
                'ads4',
                'advantage',
                'geoLinks',
                'dataList',
                'realEstateLinks',
                'popularList',
                'relatedLinks',
                'popularSearches',
                'bannerAd',
                'mvtFooter',
            ];
        },
        showSearchSchool() {
            return this.msp.searchType !== 'COUNTY';
        },
        showMarketTrends() {
            return this.getSplit('movoto-seo-optimisation-CW-4173');
        },
        /** When true (CW-4173), school is a separate reorderable block and appears after marketTrendsBlock. */
        schoolBlockReorderable() {
            return this.getSplit('movoto-seo-optimisation-CW-4173');
        },
        /** Whether to render the school block (for CW-4173: only when school content is shown). */
        showSchoolBlock() {
            if (this.msp.mspGeoContent) {
                return !this.msp.mspGeoContent.school;
            }
            return true;
        },
    },
    watch: {
        mspStatusChanged: {
            handler(newVaule, oldValue) {
                if (!!newVaule !== !!oldValue) {
                    this.forceRerender();
                }
            },
        },
        getMarketInfo: {
            handler(newVaule, oldValue) {
                this.populateFaqs();
            },
        },
    },
    methods: {
        ...mapActions('msp', ['getHottestArticles']),
        // toggle() {
        //     this.showMore = !this.showMore;
        // },
        forceRerender() {
            this.hotleadKey += 1;
        },
        getPopularSearches() {
            let dataToUrlPopularSearches = {
                singleFamilyForSale: 'single-family',
                condoAndTownhouses: 'condos',
                openHouses: 'open-houses',
                realEstateWithPool: 'att-pool',
                priceReducedHomesForSale: 'reduced-30',
                newListingsForSale: 'new-7',
                newConstructionForSale: 'new-construction',
                threeDimensionalTour: 'virtual-tour',
            };
            let popularKeys = Object.keys(dataToUrlPopularSearches);
            popularKeys.forEach((item) => {
                let eachItem = {
                    title: this.molang(`search.common.${item}`) + ' ' + this.molang('search.common.nearMe'),
                    link: `${this.glb.appUrl}for-sale/${dataToUrlPopularSearches[item]}/`,
                    key: item,
                };
                this.popularSearchesList.push(eachItem);
            });
            return this.popularSearchesList;
        },
        populateFaqs() {
            const pageData = {
                marketSummary: this.getMarketInfo,
                topNeighborhoodList: [...this.getNearbyNeighborhood],
                snapshotData: this.getSnapshotData,
                localHighlightGeo: this.getLocalHighlightGeo,
                schoolData: this.getSchoolData,
                searchType: this.msp.searchType,
                contentVariant: this.msp.contentVariant,
            };
            this.faq = faqFunc.getFaqData(pageData, this.geo, this.glb.appUrl, this.getSplit);
        },
        completed(index) {
            if (this.$refs.lazyload[index] && this.$refs.lazyload[index].ready) {
                this.$refs.lazyload[index].ready();
            }
        },
    },
    created() {
        if (this.geo.hasGeoInfo) {
            this.populateFaqs();
            if (this.geo.geoType == 'GPS') {
                this.popularSearchesList = this.getPopularSearches();
            }
        }
    },
    mounted() {
        this.componentMounted = true;
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'footer', en: enJSON, es: esJSON });
    },
};
